module.exports = __webpack_public_path__ + "img/expect.6727a700.png";